import { useCallback, useState } from 'react'

import { Reset } from '@factorialco/f0-react/icons/app'

import ToolbarButton from 'modules/expenses/components/ExpenseFileViewer/PdfViewer/ToolbarButton'

import {
  getNextRotation,
  getStoredRotation,
  storeRotation,
} from 'modules/expenses/components/ExpenseFileViewer/rotationUtils'
import './index.styles.css'

interface Props {
  url: string
  fileId?: string | null
}

export const ImageViewer = ({ url, fileId }: Props) => {
  const [rotation, setRotation] = useState(() => getStoredRotation(fileId ?? null))

  const onRotate = useCallback(() => {
    setRotation((prev) => {
      const next = getNextRotation(prev)
      storeRotation(fileId ?? null, next)
      return next
    })
  }, [fileId])

  const isSideways = rotation === 90 || rotation === 270

  return (
    <div className="ImageViewer_container">
      <div className="ImageViewer_toolbar">
        <ToolbarButton ariaLabel="Rotate" onClick={onRotate} icon={Reset} />
      </div>

      <div className="ImageViewer_imageWrapper">
        <img
          src={url}
          className={`ImageViewer_image ${isSideways ? 'ImageViewer_image--sideways' : ''}`}
          style={{ transform: `rotate(${rotation}deg)` }}
        />
      </div>
    </div>
  )
}
